import React from "react";
import { Link, useLocation } from "react-router-dom";
import NavItem from "../atoms/NavItem";
import IconRenderer from "../atoms/IconRenderer";

const NavLink = ({
  to,
  icon,
  iconType,
  isWhite = false,
  children,
  isExpanded = true,
  className = "",
  isLogout = false,
  onLogout,
  ...props
}) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  const handleClick = (e) => {
    if (isLogout && onLogout) {
      e.preventDefault();
      onLogout();
    }
  };

  return (
    <Link to={to} className="block" onClick={handleClick}>
      <NavItem
        isActive={isActive}
        isExpanded={isExpanded}
        className={className}
        title={children}
        {...props}
      >
        <IconRenderer
          icon={icon}
          iconType={iconType}
          isWhite={isWhite}
          size="md"
          className={isExpanded ? "mr-3" : ""}
        />
        {isExpanded && (
          <span className="truncate">{children}</span>
        )}
      </NavItem>
    </Link>
  );
};

export default NavLink;
